var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-rating',{attrs:{"background-color":"primary","readonly":"","value":4}})}
var staticRenderFns = []

export { render, staticRenderFns }